var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckoutIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6641 6.36438C11.6641 9.12438 9.42406 11.3644 6.66406 11.3644C3.90406 11.3644 1.66406 9.12438 1.66406 6.36438C1.66406 3.60438 3.90406 1.36438 6.66406 1.36438C9.42406 1.36438 11.6641 3.60438 11.6641 6.36438Z",
    stroke: "#444444",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.52047 7.95426L6.97047 7.02926C6.70047 6.86926 6.48047 6.48426 6.48047 6.16926V4.11926",
    stroke: "#444444",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckoutIcon);
export default __webpack_public_path__ + "static/media/checkout-icon.19ba4bd792fe82980958e7352426749c.svg";
export { ForwardRef as ReactComponent };